<form [formGroup]="form">
  <div class="form-section">
    <h3>{{ 'section.vehicleData' | translate }}</h3>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'field.targa' | translate }}</mat-label>
        <input matInput [value]="preselectedTarga" readonly />
      </mat-form-field>
    </div>

    @if (showVehicleFields) {
      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'field.brand' | translate }}</mat-label>
          <input matInput formControlName="brand" [readonly]="areVehicleFieldsReadonly" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'field.modello' | translate }}</mat-label>
          <input matInput formControlName="modelloBus" [readonly]="areVehicleFieldsReadonly" />
        </mat-form-field>
      </div>
    }
  </div>

  <div class="form-section">
    <h3>{{ 'section.driverData' | translate }}</h3>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'field.autista' | translate }}</mat-label>
        <!-- Opzione e hint "AUTISTA NON DISPONIBILE" rimossi: l'autista è obbligatorio. -->
        <mat-select
          formControlName="selectedDriverId"
          required
          panelClass="driver-select-panel"
          (openedChange)="onDriverSelectOpenedChange($event)">
          <div class="driver-select-search" (click)="$event.stopPropagation()">
            <input
              type="text"
              class="driver-select-search-input"
              [value]="driverSearchTerm"
              (input)="onDriverSearchChange($any($event.target).value)"
              (keydown)="$event.stopPropagation()"
              [placeholder]="'driver.search' | translate" />
          </div>
          @for (driver of filteredDrivers; track driver.id) {
            <mat-option [value]="driver.id">{{ getDriverDisplayName(driver) }}</mat-option>
          }
          @if (filteredDrivers.length === 0) {
            <mat-option disabled>{{ 'driver.noResults' | translate }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="help-spacing"></div>

    <div class="form-row phone-row">
      <app-international-phone-input
        formControlName="telefono"
        [required]="true"
        (validationChange)="onPhoneValidationChange($event)">
      </app-international-phone-input>
    </div>
  </div>
</form>
